

















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'SorewardsCostCell'
})
export default class extends Vue {
  @Prop({ required: true }) private value!: number
  @Prop({ default: false }) private negotiated!: boolean
  @Prop({ required: true }) private caretakerShare!: number
}
